<template>
  <div>
    <h4 class="headerTitle mt-2  mb-2">
      Cônjuge {{ propOrdem + 1 }}
    </h4>
    <div class="dados_pessoa pl-2 pr-2">
      <div class="row align-items-end">
        <div class="col-3">
          <div class="form-group">
            <label :for="`pessoa_cpf_${ _uid }`"
                   class="label"
                   :class="{'label_error': error_cpf}">
              CPF
              <IconSvg v-if="error_cpf"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <input :id="`pessoa_cpf_${ _uid }`"
                   ref="cpf_conjuge"
                   v-model="pessoa.cpf"
                   v-mask="{ mask:'999.999.999-99' }"
                   v-validate="{ regex: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/, min: 14, max: 14 }"
                   :class="{ 'is-invalid': errors.has('cpf') || error_nome }"
                   maxlength="14"
                   minlength="14"
                   :disabled="!!pessoa.cpf_sem_inscricao"
                   type="tel"
                   name="cpf"
                   class="form-control form-control-sm"
                   @change="emitChange('cpf'), searchCPF()">
            <small v-if="errors.has(null, 'cpf')"
                   class="invalid-feedback">{{ errors.first('cpf') }}</small>
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <span class="custom-control custom-switch">
              <input
                :id="`pessoa_desconhecida${ propOrdem }`"
                ref="sem_inscricao"
                v-model="pessoa.cpf_sem_inscricao"
                class="custom-control-input"
                name="tipo_registro"
                type="checkbox"
                :value="1"
                @change="pessoa.cpf = null, emitChange()">
              <label
                class="custom-control-label"
                :for="`pessoa_desconhecida${ propOrdem }`">Sem inscrição</label>
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label :for="`pessoa_nome_${ _uid }`"
                   class="label"
                   :class="{'label_error': error_nome}">
              Nome <span class="text-danger">*</span>
              <IconSvg v-if="error_nome"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <input :id="`pessoa_nome_${ _uid }`"
                   v-model.lazy="pessoa.nome_antigo"
                   v-validate="'required'"
                   v-uppercase
                   :class="{'is-invalid': errors.has('pessoa_nome') || error_nome}"
                   type="text"
                   class="form-control form-control-sm text-uppercase"
                   name="pessoa_nome"
                   @change="emitChange(null,'nome'), $emit('onNomeChanged')">
            <small v-if="errors.has('pessoa_nome')"
                   class="invalid-feedback">
              {{ errors.first('pessoa_nome') }}
            </small>
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <label :for="`pessoa_nome_novo_${ _uid }`"
                   class="label"
                   :class="{'label_error': error_novo_nome}">
              Nome novo
              <IconSvg v-if="error_novo_nome"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <input :id="`pessoa_nome_novo_${ _uid }`"
                   v-model.lazy="pessoa.nome"
                   v-uppercase
                   :class="[{'is-invalid': error_novo_nome}, 'nome_novo']"
                   type="text"
                   class="form-control form-control-sm text-uppercase"
                   @change="emitChange(null, 'nome_novo')">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-2">
          <div class="form-group">
            <label
              class="label"
              :class="{'label_error': error_sexo}"
              :for="`pessoa_sexo_${ _uid }`">Sexo
              <IconSvg v-if="error_sexo"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <div class="m-0 p-0"
                 :class="{'border-error': error_sexo}">
              <v-select :id="`pessoa_sexo_${ _uid }`"
                        v-model="pessoa.sexo"
                        class="form-control form-control-sm"
                        :class="{'is-invalid': error_sexo}"
                        label="name"
                        :reduce="sexo => sexo.value"
                        :options="options.SEXOS"
                        @input="emitChange(null, 'sexo')" />
            </div>
          </div>
        </div>

        <div class="col-2">
          <div class="form-group">
            <label :for="`pessoa_data_nascimento_${ _uid }`"
                   class="label"
                   :class="{'label_error': error_data}">
              Data de Nascimento
              <IconSvg v-if="error_data"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <input :id="`pessoa_data_nascimento_${ _uid }`"
                   v-model="pessoa.data_nascimento"
                   v-validate="`date_format:yyyy-MM-dd|date_between:1500-01-01,${limitDate}`"
                   :name="`genitor_data_nascimento_${ propOrdem }_${ _uid }`"
                   type="date"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has(`genitor_data_nascimento_${ propOrdem }_${ _uid }`) || !!pessoa.data_nascimento && pessoa.idade < 14 }"
                   @change="nascimentoHandler">
            <small v-if="errors.has(`genitor_data_nascimento_${ propOrdem }_${ _uid }`)"
                   class="text-danger">
              {{ errors.first(`genitor_data_nascimento_${ propOrdem }_${ _uid }`) }}
            </small>
            <small v-else-if="!!pessoa.data_nascimento && pessoa.idade < 14"
                   class="text-danger">
              Idade menor que o permitido para realização do casamento.
            </small>
          </div>
        </div>

        <div class="col-2">
          <div class="form-group">
            <label
              class="label"
              :class="{'label_error': error_nacionalidade}"
              for="pessoa_nacionalidade">Nacionalidade
              <IconSvg v-if="error_nacionalidade"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <div class="m-0 p-0"
                 :class="{'border-error': error_nacionalidade}">
              <Nacionalidades v-model="pessoa.nacionalidade_codigo"
                              :prop-nacionalidade="pessoa.nacionalidade"
                              :prop-sexo="pessoa.sexo"
                              class="m-0 p-0"
                              @updated="changeNacionalidade" />
            </div>
          </div>
        </div>

        <div v-if="pessoa.nacionalidade_codigo === 76"
             class="col-2">
          <div class="form-group">
            <label
              class="label"
              :for="`pessoa_uf_${ _uid }`">UF</label>
            <select :id="`pessoa_uf_${ _uid }`"
                    v-model="pessoa.uf"
                    class="form-control form-control-sm"
                    @change="filterCities">
              <option :value="null">
                Selecione um estado:
              </option>
              <option v-for="estado in options.estados"
                      :key="`${ _uid }_${ estado.uf }`">
                {{ estado.uf }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="show_naturalidade"
             class="col-4">
          <div class="form-group">
            <label
              class="label"
              :class="{'label_error': error_naturalidade}"
              :for="`pessoa_naturalidade_${ _uid }`">Naturalidade
              <IconSvg v-if="error_naturalidade"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <div class="m-0 p-0"
                 :class="{'border-error': error_naturalidade}">
              <v-select :id="`pessoa_naturalidade_${ _uid }`"
                        v-model="pessoa.naturalidade"
                        :options="options.cidades.map(cidade => cidade.nome)"
                        :show-labels="false"
                        :searchable="pessoa.uf !== 'EX'"
                        :taggable="pessoa.uf !== 'EX'"
                        placeholder="Selecione"
                        :class="{'is-invalid': error_naturalidade}"
                        @input="emitChange(null, 'naturalidade')"
                        @close="emitChange(null, 'naturalidade')" />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-if="showNatDeclarada"
             class="col-4 col-sm-6">
          <div class="form-group">
            <label
              class="label"
              :class="{'label_error': error_naturalidade}"
              :for="`naturalidade_declarada_${ _uid }`">Naturalidade declarada
              <IconSvg v-if="error_naturalidade"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <input id="naturalidade_declarada"
                   v-model="pessoa.naturalidade_declarada"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': error_naturalidade}"
                   name="naturalidade_declarada"
                   type="text"
                   @change="emitChange(null, 'naturalidade')">
          </div>
        </div>
      </div>
    </div>

    <Genitores
      :genitores="propPessoa.genitores"
      :endereco-registrado="propPessoa.endereco || {}"
      :pessoa-id="pessoa.pessoa_id"
      :campo-declarante="false"
      :read-only="true"
      :prop-cartorio="propCartorio"
      :prop-correcoes="propCorrecoes"
      :prop-ordem="propOrdem + 1"
      :prop-data="{ registro: { pessoa: { data_nascimento: pessoa.data_nascimento } } }"
      @genitorAdded="addGenitor"
      @genitorUpdated="updateGenitor"
      @genitorRemoved="deleteGenitor"
      @removeEndereco="removeEnderecoGenitor"
      @removeDocumento="removeDocumentoGenitor"
      @deleteError="deleteError" />
  </div>
</template>

<script>
/* constants */
  import SEXOS from "@/constants/sexos"
  import { ESTADOS_CIVIL_HABILITACAO } from "@/constants/estadosCivil"
  import brazilianStates from "@/constants/brazilianStates"
  import cidades from "@/constants/repositorio/cidades"

  /* components */
  import Genitores from "@/components/SofiaRei/Obito/Passos/Sessoes/Genitores"
  import Nacionalidades from "@/components/SofiaRei/Nacionalidades"

  /* services */
  import PessoasService from "@/services/Pessoas"

  /* filters */
  import { filterDate,filterMaskedNumber } from '@/filters/filters'

  /* others */
  import moment from "moment"

  export default {
    name: "ConjugeLegado",
    components: {
      Genitores,
      Nacionalidades,
    },
    inject: ['$validator'],
    props: {
      readOnly: { type: Boolean, default: ()=> false},
      propOrdem: [Number, String],
      propPessoa: {
        type: Object,
        default: () => {
          return {
            pessoa: {}
          }
        }
      },
      propCartorio: { type: Object, default: () => { return {} } },
      propHabilitacao: { type: Object, default: () => ({})},
      propCorrecoes: { type: Object, default: () => ({})},
      propComponentePai: { type: String, default: () => null}
    },
    data () {
      return {
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        data_nascimento: '',
        constants: {
          brazilianCities: []
        },
        options: {
          SEXOS,
          ESTADOS_CIVIL_HABILITACAO,
          estados: brazilianStates,
          cidades: []
        },
        loading: { },
        disableds: {
          desconhecido: false
        },
        show: {
          idade: true
        },
        pessoa: {
          contato: null,
          nome: null,
          nome_antigo: null,
          uf: "SP",
          naturalidade: null,
          registrosAnteriores: [],
          endereco: null,
          documentos: [],
          genitores: [],
          ...this.propPessoa
        },
        optionsPartilha: [
          {
            name: 'Sim',
            value: true
          },
          {
            name: 'Não',
            value: false
          }
        ],
        error_cpf: false,
        error_nome: false,
        error_novo_nome: false,
        error_data: false,
        error_sexo: false,
        error_ocupacao: false,
        error_pais: false,
        error_nacionalidade: false,
        error_naturalidade: false,
        error_texto_livre: false,
        show_naturalidade: true
      }
    },
    computed: {
      showNatDeclarada () {
        let { nacionalidade_codigo } = this.pessoa

        if (nacionalidade_codigo && nacionalidade_codigo != 76) {
          return true
        }

        return (this.pessoa.naturalidade === 'Outro')
      }
    },
    watch: {
      propPessoa () {
        this.pessoa = {
          ...this.propPessoa
        }

        this.init()

        this.$validator.reset()
      },
      propCartorio () {
        this.init()
      },
      propOrdem () {
        !this.pessoa.cpf_sem_inscricao ? this.$refs["cpf_conjuge"].focus() : this.$refs["sem_inscricao"].focus()
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      }
    },
    async created () {
      this.constants.brazilianCities = cidades
      if (this.constants && this.constants.brazilianCities.length) this.filterCities()

      this.init()
    },
    mounted () {
      this.$validator.reset()
      this.verifyErrorsCarga()

      setTimeout(() => {
        !this.pessoa.cpf_sem_inscricao ? this.$refs["cpf_conjuge"].focus() : this.$refs["sem_inscricao"].focus()
      }, 100)
    },
    methods: {
      init () {
        if (this.propCartorio && this.propCartorio.endereco && !this.pessoa.nome_antigo) {
          this.pessoa.uf = this.propCartorio.endereco.uf
          this.pessoa.naturalidade = this.propCartorio.endereco.cidade

          this.filterCities()
        }

        if (!this.propPessoa.novo_antigo && this.propPessoa.pivot) {
          this.pessoa.novo_antigo = this.propPessoa.pivot.nome_antigo
        }

        if (this.pessoa.nacionalidade_codigo != 76) {
          this.show_naturalidade = false
        } else {
          this.show_naturalidade = true
        }

        if (this.pessoa.uf !== 'EX') this.filterCities()

        if (this.propPessoa && this.propPessoa.pessoa_id) {
          this.pessoa.existe_partilha = !!this.pessoa.existe_partilha
          this.pessoa.efetuou_partilha = !!this.pessoa.efetuou_partilha
        }

        if (this.pessoa.cpf) {
          const cpfNumber = this.pessoa.cpf.replace(/[^\d]/g, "")
          this.pessoa.cpf = cpfNumber.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
        }

        this.pessoa.estado_civil = 'CASADO'
      },
      async searchCPF () {
        let cpf = filterMaskedNumber(this.pessoa.cpf)

        if (cpf && cpf.length > 10) {
          const dados = await PessoasService.getPessoaByCPF(cpf)

          if (dados.isEmpty) return

          const { nome, datanascimento, sexo, nomemae } = dados

          const sexos = {
            1: 'M',
            2: 'F'
          }

          if (nomemae) {
            // deixando sexo feminino temporário para se adaptar ao que vem da CRC
            const mother = this.pessoa.genitores.find(genitor => genitor.pessoa.nome == nomemae)
            if (!mother) {
              this.pessoa.genitores = []
              this.pessoa.genitores.push({ pessoa: { nome: nomemae, sexo: "F" } })
            }
          }

          this.pessoa.nome_antigo = nome

          let dataNascimento = filterDate(datanascimento)

          this.pessoa.data_nascimento = dataNascimento.split('/').reverse().join('-')

          this.calculateAge()

          this.pessoa.sexo = sexos[sexo] || 'I'

        }

        this.pessoa.cpf = this.pessoa.cpf || null

        this.emitChange()
        this.$emit('onNomeChanged', null)
      // this.activeChange()
      },
      nascimentoHandler () {
        !this.pessoa.data_nascimento ? this.pessoa.data_nascimento = null : ''
        this.calculateAge()
        this.emitChange()
      },
      emitChange (deleteds = null, field) {
        if (field) {
          const ordem = this.propOrdem + 1

          switch (field) {
          case 'cpf':
            this.deleteError([`CPF DO CÔNJUGUE ${ordem}`])
            break
          case 'nome':
            this.pessoa.nome_antigo = this.pessoa.nome_antigo.toUpperCase()
            this.deleteError([`NOME DO CÔNJUGUE ${ordem}`])
            break
          case 'nome_novo':
            this.pessoa.nome = this.pessoa.nome.toUpperCase()
            this.deleteError([`NOVO NOME DO CÔNJUGUE ${ordem}`])
            break
          case 'sexo':
            this.deleteError([`SEXO DO CÔNJUGE ${ordem}`])
            break
          case 'data':
            this.deleteError([`DATA DE NASCIMENTO DO CÔNJUGE ${ordem}`])
            break
          case 'nacionalidade':
            this.deleteError([`PAIS DE NASCIMENTO DO CÔNJUGE ${ordem}`, `NACIONALIDADE DO CÔNJUGE ${ordem}`])
            break
          case 'naturalidade':
            this.deleteError([`CÓDIGO IBGE DO MUNICÍPIO DE NATURALIDADE DO CÔNJUGE ${ordem}`])
            break
          }
        }

        if (['DIVORCIADO', 'VIUVO'].indexOf(this.pessoa.estado_civil) < 0) {
          this.pessoa = {
            ...this.pessoa,
            existe_partilha: null,
            efetuou_partilha: null
          }
        }

        if (deleteds !== null) {
          this.$emit('onDeleteds', deleteds)
        }

        this.$emit('onChange', {
          ordem: this.propOrdem,
          pessoa: this.pessoa
        })
      },
      cpfDuplicate (genitor) {
        let data = {
          duplicated: false
        }

        this.pessoa.genitores.forEach((gen, index) => {
          const {pessoa} = gen

          if (pessoa.cpf && (genitor.localId != index)) {
            if (pessoa.cpf == genitor.pessoa.cpf) {
              data.duplicated = true
              data.field = 'genitor'
              data.genitor = gen
            }
          }
        })

        if (this.pessoa.cpf) {
          if (genitor.pessoa.cpf === this.pessoa.cpf) {
            data.duplicated = true
            data.field = 'conjuge'
          }
        }

        if (data.duplicated) {
          let text = null

          switch (data.field) {
          case 'genitor':
            text = `CPF já cadastrado para o genitor ${data.genitor.pessoa.nome}`
            break
          case 'conjuge':
            text = `CPF já cadastrado para o cônjuge ${this.pessoa.nome}`
            break
          }

          objSwal.error.title = `Erro ao cadastrar genitor ${genitor.pessoa.nome}`
          objSwal.error.text = text
          Swal.fire(objSwal.error)
        }

        return data.duplicated
      },
      addGenitor (genitor) {
        delete genitor.pessoa.predefineAddress
        if (!this.cpfDuplicate(genitor)) {
          this.pessoa.genitores.push(genitor)

          objSwal.success.title = "Adicionado com Sucesso"
          objSwal.success.text = ''
          Swal.fire(objSwal.success).then(() => {
            setTimeout(() => {
              const btnAdd = document.querySelector(`.addGenitor_${this.propOrdem + 1}`)

              if (btnAdd) btnAdd.focus()
            }, 200)
          })
          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)

          this.emitChange()
        }
      },
      updateGenitor (genitor, index) {
        if (!this.cpfDuplicate(genitor)) {
          this.pessoa.genitores[index] = genitor
          this.emitChange()
        }
      },
      deleteGenitor (index) {
        const { genitores } = this.pessoa

        let deleteds = null

        if (genitores[index] && genitores[index].genitor_id) {
          deleteds = {
            genitores: genitores[index].genitor_id
          }
        }

        this.pessoa.genitores.splice(index, 1)
        this.emitChange(deleteds)
      },
      changeNacionalidade (nacionalidade) {
        this.pessoa.nacionalidade = nacionalidade

        if (this.pessoa.nacionalidade.nome === "Brazil" || this.pessoa.nacionalidade.nome === "Brasil") {
          this.pessoa.uf = null
          this.show_naturalidade = true
          this.pessoa.naturalidade_declarada =  null
        } else {
          this.pessoa.naturalidade = null
          this.show_naturalidade = false
          this.pessoa.uf = "EX"
        }

        this.emitChange(null, 'nacionalidade')
      },
      async filterCities () {
        if (!this.pessoa.uf) return

        if (this.pessoa.uf === 'EX') {
          this.options.cidades = [{nome: 'Outro'}]
          this.pessoa.naturalidade = 'Outro'

          this.emitChange()

          return
        }

        const state = this.options.estados.find(estado => estado.uf == this.pessoa.uf)
        const cities = cidades.filter(cidade => cidade.codigo_uf == state.ibgeId)

        cities.push({nome: 'Outro'})

        this.options.cidades = cities
      },
      removeDocumentoGenitor (documento) {
        if (documento.pessoa_documento_id) {
          const deleteds = {
            pessoaDocumentos: documento.pessoa_documento_id
          }

          this.emitChange(deleteds)
        }
      },
      calculateAge () {
        this.show.idade = false

        let dataComparacao = moment()

        if (this.propHabilitacao && this.propHabilitacao.registro && this.propHabilitacao.registro.data_registro) {
          dataComparacao = this.propHabilitacao.registro.data_registro
        }

        this.pessoa.idade = moment(dataComparacao).diff(moment(this.pessoa.data_nascimento), 'years')
        this.show.idade = true
      },
      removeEnderecoGenitor (endereco) {
        if (endereco.endereco_id) {
          const deleteds = {
            pessoaEnderecos: endereco.endereco_id
          }
          this.emitChange(deleteds)
        }
      },
      verifyErrorsCarga () {
        this.error_cpf = false,
        this.error_nome = false,
        this.error_novo_nome = false,
        this.error_data = false,
        this.error_sexo = false,
        this.error_ocupacao = false,
        this.error_pais = false,
        this.error_nacionalidade = false,
        this.error_naturalidade = false,
        this.error_texto_livre = false

        const ordem = this.propOrdem + 1
        Object.keys(this.propCorrecoes).forEach(key => {
          if ([`CPF DO CÔNJUGUE ${ordem}`].indexOf(key) != -1) this.error_cpf = true
          if ([`NOME DO CÔNJUGUE ${ordem}`].indexOf(key) != -1) this.error_nome = true
          if ([`NOVO NOME DO CÔNJUGUE ${ordem}`].indexOf(key) != -1) this.error_novo_nome = true
          if ([`SEXO DO CÔNJUGE ${ordem}`].indexOf(key) != -1) this.error_sexo = true
          if ([`DATA DE NASCIMENTO DO CÔNJUGE ${ordem}`].indexOf(key) != -1) this.error_data = true
          if ([`CÓDIGO DA OCUPAÇÃO DECLARADA DO CÔNJUGE ${ordem}`].indexOf(key) != -1) this.error_ocupacao = true
          if ([`PAIS DE NASCIMENTO DO CÔNJUGE ${ordem}`,`NACIONALIDADE DO CÔNJUGE ${ordem}`].indexOf(key) != -1) this.error_nacionalidade = true
          if ([`CÓDIGO IBGE DO MUNICÍPIO DE NATURALIDADE DO CÔNJUGE ${ordem}`].indexOf(key) != -1) this.error_naturalidade = true
          if ([`TEXTO LIVRE DO MUNICÍPIO DE NATURALIDADE DO CÔNJUGE ${ordem}`].indexOf(key) != -1) this.error_texto_livre = true
        })
      },
      deleteError (errors) {
        this.$emit('deleteError', errors)
      },
    }
  }
</script>

<style lang="scss">
@import '../../../../scss/_utilities/exports';

.documentosBox {
  &_header {
    @extend %titleBox;
    background-color: $color-gray-light;
    margin-top: 1rem;
  }
}

.widthIdade {
  -webkit-box-flex: 0;
  flex: 0 0 15%;
  max-width: 15%;
}

.widthEstadoCivil {
  -webkit-box-flex: 0;
  flex: 0 0 29.7%;
  max-width: 29.7%;
}

.labelPartilhaBens {
  font-size: 15px;
}

.particao {
  border-bottom: 1px dashed rgba(38, 38, 38, 0.3);
}
</style>
